<!--<app-ctl-spinning-loader [isLoading]="loaded"></app-ctl-spinning-loader>-->

<div class="white" *ngIf="subjectList?.length">
    <p class="marL10 marB20 dark-text">{{'Assign subjects to this grade' | translate}}</p>
    <div class="grey-text" style="float: left;margin-left: 10px; margin-right: 10px;">
        {{'Subjects' | translate}}
    </div>
    <div class="slist" style="overflow:auto; overflow-x: hidden;padding-bottom: 20px;padding-right: 20px;">
        <div *ngFor="let item of mySubjectList let i = index">
            <div class="checkbox">
                <label><input type="checkbox" [checked]="isChecked(item)" (change)="checkUncheckSubject(item)">{{item.name | ucfirst}}</label>
            </div>
        </div>
    </div>
    <div style="clear:both"></div>
    <div class="info-section"><img src="assets/images/info.png" style="float: left;">&nbsp;<label>{{'To add a subject not listed here' | translate}}</label></div>
</div>

